/*!
 * AASlideScroller Library v1.1
 * codecanyon.net/user/AA-Team/portfolio
 *
 * Copyright 2011, AA-Team
 *
 * Date: 14.11.2011
 !*/
 
 /*
	AASlideScroller ChangeLog
	-------------------------
	
	Version 1.1 (21.11.2011)
		Fixed bug
		Opera overflow scrollLeft problem. Condition for margin left first UL if is Opera.
		
 */

(function ($) {
    $.fn.AASlideScroller = function (options) {
        var defaults = {
			animationSpeed: 350,
			gridWidth: 730,
			slideWidth: 730,
			easing: 'easeInSine',
			gridElm: '.horizontal-slider',
			grid: {
				promoWrapper: null,
				content: null,
				items: null,
				length: 0,
				promoImgs: null,
				resized	: false,
				show: 0,
				width: 0
			},
			slider: {
				elm: null,
				contentWrapper: null,
				content: null,
				buttonWidth: 60 // min 55
			},
			prev: '.arrow-left',
			next: '.arrow-right',
			mouseWheel: true,
			keyBrowse: true,
			haveScrollbar: true,
			pauseOnHover: true,
			autoplay: false, // autoplay easing
            autoplaySpeed: 3000, // autoplay interval speed
            pauseOnHover: false, // if autoplay on mouse over make pause (true|false - default false)
			running: false,
            animationStart: function () {},
            animationComplete: function () {}
        };
        var option = $.extend({}, defaults, options);
        return this.each(function () {
            var $t = $(this),
				step = 0,
				isOpera = false,
				l = 0,
				play, cc = 0;
				
            var slider = {
                init: function () {
					if($.browser.opera) {
						isOpera = true;
					}
					slider.load();
                },
				
				grid_init: function()	{
					option.grid.promoWrapper = $t.find(option.gridElm);
					option.grid.content = option.grid.promoWrapper.find('.content').first();
					
					if(isOpera === true) {
						option.grid.contentUl = option.grid.promoWrapper.find('.content').first().find('ul').first();
					}
					option.grid.content.width(option.gridWidth);
					
					slider.buildGrid();
				},
				
				buildGrid: function() {
					option.grid.items = option.grid.promoWrapper.find('.promo-item li');
					l = option.grid.length = option.grid.items.size();
					option.grid.promoImgs = option.grid.promoWrapper.find('img');
					option.grid.width = option.grid.items.eq(0).outerWidth() + parseInt(option.grid.items.eq(0).css('margin-left'));
					option.grid.show = Math.round(option.grid.promoWrapper.width() / option.grid.width);
					
					option.grid.items.each(function(){
						var $this = $(this),
							$description = $this.find('.description'),
							$fullDesc = $description.children('p');
						
						$fullDesc.hide();
					});
					
					slider.grid_triggers();
				},
				
				grid_triggers: function() {
					option.grid.items.children('a').hover(function(){
						var $this = $(this),
							$description = $this.find('.description p');
							
						$description.stop(true, true).slideDown(150, 'easeOutCubic');
					}, 
					function(){
						var $this = $(this),
							$description = $this.find('.description p');

						$description.stop(true, true).slideUp(250, 'easeOutCubic');
					});
				},
				
				load: function(){
					slider.grid_init();
					
					option.slider.elm = $t.find('.scroll-bar');
					option.slider.content = option.slider.elm.find('.content'),
					option.slider.contentWrapper = option.slider.content.find('.slider-wrapper');
					
					// set slide width
					option.slider.elm.width(option.slideWidth);
					
					// init layout init (resize buttons)
					slider.initLayout();
					
					// init triggers of slider
					slider.trigger();
				},
				
				initLayout: function() {
					var slide = option.slider.content.find('span.slide'),
						sliderWrapper = option.slider.contentWrapper,
						btnWidth = 21; // next back controller width
						newSlideWidth = option.slider.content.width() - ((btnWidth * 2) + 2 /* borders, left - right*/);
						
					// reset width to slide
					slide.width(newSlideWidth);
					sliderWrapper.width(newSlideWidth - (option.slider.buttonWidth - 8 /* button drop shadown */));
					
					// Button
					var buttonContainer = option.slider.content.find('div.slide-btn'),
						btnWidth = 21; // left right button label width
						buttonMiddle	= buttonContainer.find('span.middle');
					
					buttonContainer.width(option.slider.buttonWidth);
					buttonMiddle.width(option.slider.buttonWidth - (btnWidth * 2));
					
					// go slide to scroll left 0
					option.grid.content.scrollLeft(0);
				},
				
				moveSlide: function() {
					if(option.slider.contentWrapper.slider( "value") != step) {
						// set slider to step
						option.slider.contentWrapper.slider( "value", step);
					}
					
					if(isOpera === true) {
						option.grid.contentUl.stop().animate({
							marginLeft: "-" + Math.round(step * option.grid.width) + "px"
						}, option.animationSpeed, option.easing, function() {
							
							// call function at the end of slide
							option.animationComplete.call(this);
								
							// release running
							option.running = false;
						});
					}else{
						option.grid.content.stop().animate({
							scrollLeft: Math.round(step * option.grid.width)
						}, option.animationSpeed, option.easing, function() {
							
							// call function at the end of slide
							option.animationComplete.call(this);
								
							// release running
							option.running = false;
						});
					}
				},
				
				animation: {
                    previous: function (fromStart) {
                        if(step === 0){
                            step = (l - option.grid.show);
                        } else {
                            step--;
                        }
                        slider.moveSlide();
                    },
                    next_item: function (fromStart) {
                        if(step === ((l - option.grid.show))){
                            step = 0;
                        }else{
                            step++;
                        }
						slider.moveSlide();
                    }
                },
				
                keyBrowse: function () {
					$(document).keyup(function(e) {
						// exit if animations still running
						if(option.running){
							return false;
						}
						
						// set up true running script
						option.running = true;
						
						if (e.keyCode === 37){
							slider.animation.previous();
						}
						if (e.keyCode === 39){
							slider.animation.next_item();
						}
						return false;
					});
                },

                mouseWheel: function () {
                    $t.mousewheel(function(event, delta) {
                        // exit if animations still running
                        if(option.running){
                            return false;
                        }

                        // set up true running script
                        option.running = true;

                        var dir = delta > 0 ? 'up' : 'down',
                        vel = Math.abs(delta);
                        if(dir === 'down'){
                            slider.animation.next_item();
                        }else{
                            slider.animation.previous();
                        }
                        return false;
                    });
                },
				
                autoplay: function () {
					play = setInterval(function () {
						slider.animation.next_item();
					}, option.autoplaySpeed);
                    
                },
				
                pause: function () {
                    clearInterval(play);
                },
				
				trigger: function() {
				
					if(option.haveScrollbar) {
						option.slider.contentWrapper.slider({
							min: 0,
							animate: true,
							max: option.grid.length - option.grid.show,
							change: function( event, ui ) {
								step = ui.value;
								slider.moveSlide();
							}
						});
					}
					
					$t.find(option.prev).click(function () {
						// exit if animations still running
						if(option.running){
							return false;
						}
						
						// set up true running script
						option.running = true;
					
						slider.animation.previous();
						return false;
					});
					$t.find(option.next).click(function () {
						// exit if animations still running
						if(option.running){
							return false;
						}

						// set up true running script
						option.running = true;
						
						slider.animation.next_item();
						return false;
					});
					
					if (option.mouseWheel === true) {
                        slider.mouseWheel();
                    }
                    if (option.keyBrowse === true) {
                        slider.keyBrowse();
                    }
					if (option.pauseOnHover === true) {
                        $t.hover(function () {
                            slider.pause();
                        }, function () {
                            slider.autoplay();
                        });
                    }
					if (option.autoplay === true) {
                        slider.autoplay();
                    }
				}
            };
			
            slider.init();
        });
    };
}(jQuery));


// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend( jQuery.easing,
{
	def: 'easeOutQuad',
	swing: function (x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function (x, t, b, c, d) {
		return c*(t/=d)*t + b;
	},
	easeOutQuad: function (x, t, b, c, d) {
		return -c *(t/=d)*(t-2) + b;
	},
	easeInOutQuad: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t + b;
		return -c/2 * ((--t)*(t-2) - 1) + b;
	},
	easeInCubic: function (x, t, b, c, d) {
		return c*(t/=d)*t*t + b;
	},
	easeOutCubic: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t + 1) + b;
	},
	easeInOutCubic: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t + b;
		return c/2*((t-=2)*t*t + 2) + b;
	},
	easeInQuart: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t + b;
	},
	easeOutQuart: function (x, t, b, c, d) {
		return -c * ((t=t/d-1)*t*t*t - 1) + b;
	},
	easeInOutQuart: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t + b;
		return -c/2 * ((t-=2)*t*t*t - 2) + b;
	},
	easeInQuint: function (x, t, b, c, d) {
		return c*(t/=d)*t*t*t*t + b;
	},
	easeOutQuint: function (x, t, b, c, d) {
		return c*((t=t/d-1)*t*t*t*t + 1) + b;
	},
	easeInOutQuint: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
		return c/2*((t-=2)*t*t*t*t + 2) + b;
	},
	easeInSine: function (x, t, b, c, d) {
		return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
	},
	easeOutSine: function (x, t, b, c, d) {
		return c * Math.sin(t/d * (Math.PI/2)) + b;
	},
	easeInOutSine: function (x, t, b, c, d) {
		return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
	},
	easeInExpo: function (x, t, b, c, d) {
		return (t==0) ? b : c * Math.pow(2, 10 * (t/d - 1)) + b;
	},
	easeOutExpo: function (x, t, b, c, d) {
		return (t==d) ? b+c : c * (-Math.pow(2, -10 * t/d) + 1) + b;
	},
	easeInOutExpo: function (x, t, b, c, d) {
		if (t==0) return b;
		if (t==d) return b+c;
		if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
		return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function (x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t/=d)*t) - 1) + b;
	},
	easeOutCirc: function (x, t, b, c, d) {
		return c * Math.sqrt(1 - (t=t/d-1)*t) + b;
	},
	easeInOutCirc: function (x, t, b, c, d) {
		if ((t/=d/2) < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
		return c/2 * (Math.sqrt(1 - (t-=2)*t) + 1) + b;
	},
	easeInElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
	},
	easeOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d)==1) return b+c;  if (!p) p=d*.3;
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		return a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b;
	},
	easeInOutElastic: function (x, t, b, c, d) {
		var s=1.70158;var p=0;var a=c;
		if (t==0) return b;  if ((t/=d/2)==2) return b+c;  if (!p) p=d*(.3*1.5);
		if (a < Math.abs(c)) { a=c; var s=p/4; }
		else var s = p/(2*Math.PI) * Math.asin (c/a);
		if (t < 1) return -.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
		return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*.5 + c + b;
	},
	easeInBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*(t/=d)*t*((s+1)*t - s) + b;
	},
	easeOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
	},
	easeInOutBack: function (x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158; 
		if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
		return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
	},
	easeInBounce: function (x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce (x, d-t, 0, c, d) + b;
	},
	easeOutBounce: function (x, t, b, c, d) {
		if ((t/=d) < (1/2.75)) {
			return c*(7.5625*t*t) + b;
		} else if (t < (2/2.75)) {
			return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
		} else if (t < (2.5/2.75)) {
			return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
		} else {
			return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
		}
	},
	easeInOutBounce: function (x, t, b, c, d) {
		if (t < d/2) return jQuery.easing.easeInBounce (x, t*2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce (x, t*2-d, 0, c, d) * .5 + c*.5 + b;
	}
});


/*! Copyright (c) 2009 Brandon Aaron (http://brandonaaron.net)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 *
 * Version: 3.0.2
 *
 * Requires: 1.2.2+
 */
(function($) {

    var types = ['DOMMouseScroll', 'mousewheel'];

    $.event.special.mousewheel = {
        setup: function() {
            var i;
            if ( this.addEventListener ){
                for ( i=types.length; i; ){
                    this.addEventListener( types[--i], handler, false );
                }
            }else{
                this.onmousewheel = handler;
            }
        },

        teardown: function() {
            var i;
            if ( this.removeEventListener ){
                for (i=types.length; i; ) {
                    this.removeEventListener( types[--i], handler, false );
                }
            }else{
                this.onmousewheel = null;
            }
        }
    };

    $.fn.extend({
        mousewheel: function(fn) {
            return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
        },

        unmousewheel: function(fn) {
            return this.unbind("mousewheel", fn);
        }
    });


    function handler(event) {
        var args = [].slice.call( arguments, 1 ), delta = 0, returnValue = true;

        event = $.event.fix(event || window.event);
        event.type = "mousewheel";

        if ( event.wheelDelta ) {
            delta = event.wheelDelta/120;
        }
        if ( event.detail     ) {
            delta = -event.detail/3;
        }

        // Add events and delta to the front of the arguments
        args.unshift(event, delta);

        return $.event.handle.apply(this, args);
    }
    
}(jQuery));